import { success, failure, request } from 'app/actions';
import * as actions from './reportGeneralPanelActions';
import * as helpers from './reportGeneralPanelHelpers';

const initialState = {
  studentsAnswersQuestionReport: [],
  generalComparativeReport: {},
  disciplineComparativeReport: [],
  questionsDetailsComparativeReport: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
